import { render, staticRenderFns } from "./SearchSuppliers.vue?vue&type=template&id=3fd87f58&scoped=true"
import script from "./SearchSuppliers.vue?vue&type=script&lang=js"
export * from "./SearchSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd87f58",
  null
  
)

export default component.exports